export default "__VITE_ASSET__BhXGMl$T__"